export function MediaUpload(media, expiryTime) {
  this.media = media;
  this.expiryTime = expiryTime;
  this.password = "";
  this.hint = "";
}
